import { Col, Row } from "react-bootstrap";
import { Table, message } from 'antd';
import styles from "./style.module.css"
import { useEffect, useState } from "react";


export default function PopupViewServices(props) {
  
  const [categoryVoucher, SetCategoryVoucher] = useState([])
  const [showPopupAddCategory, SetShowPopupAddCategory] = useState(false)
  const [dataEditCategory, setDataEditCategory] = useState([])

  const [dataSource, setDataSource] = useState([])
  function convertCurrency(data) {
      let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
      return res;
  };
  const columns = [
    {
      title: "Tên dịch vụ",
      dataIndex: 'service_name',
      width: 200,
      key: 'service_name',
    },
    {
      title: "Số lần phục vụ",
      dataIndex: 'total_service',
      width: 200,
      align: "center",
      key: 'total_service',
    },
    {
      title: "Hoa hồng",
      dataIndex: 'total_com',
      width: 200,
      align: "center",
      key: 'total_com',
      render: (data) => {
        return (<p className="text1">{convertCurrency(Number(data))}</p>)
      },
    }
  ];

  useEffect(async () => {
    try {
      if (props.dataViewService.length > 0) {
        setDataSource(props.dataViewService)
      } else {
        message.error("Đã có lỗi xảy ra")
      }
       
    } catch (error) {
      console.error(error)
      message.error("Đã có lỗi xảy ra")
    }
}, [])


  const handleAddCategory = () => {
    SetShowPopupAddCategory(!showPopupAddCategory)
    setDataEditCategory([])
  }

    return (
      <div className="popup-cent">
        <div className="content-popup fadeInDown popup-view-services">
          <div className="head-popup">
            <div className="title">Thông báo</div>
            <div className="close" onClick={props.close}>×</div>
          </div>
          <div className="body-popup">
            <Row className="d-flex justify-content-between p-2">
              <div className="title-body">Danh sách dịch vụ phục vụ</div>
              <div className="d-flex">
                  <div className={`${styles.addButton} p-3 pl-5 pr-5`} onClick={handleAddCategory}>
                      Tổng tiền: <span style={{color: '#40a9ff', fontWeight: 'bold'}}>{convertCurrency(props.detailComPv)}</span>
                  </div>
              </div>
            </Row>
            <div className="table-category_voucher">
                <Row className="mt-4">
                  <Col xs={12} className="p-2">
                      <Table 
                        dataSource={dataSource} 
                        columns={columns} 
                        pagination={false}
                        scroll={{ x: columns.length*200, y: 600 }}
                        rowKey={"service_id"}
                      />
                  </Col>
                </Row>
            </div>
          </div>
          {!showPopupAddCategory?
             <div className="bottom-popup">
             <div className="button-container">
               <div className="button-cent style3" onClick={props.close}>
                 <span><i className="fas fa-times"></i></span>Đóng
               </div>
             </div>
           </div>
          : null}
        </div>
        <div className="overlay" onClick={props.close}></div>
      </div>
    )
}
